<template>
  <div class="searchBox">
    <van-search
            v-model="searchWord"
            show-action
            shape="round"
            :placeholder="searchType"
            @search="onSearch"
            @cancel="onCancel"

    />

    <div class="selectSearch" v-if="orderType=='' && searchList.length==0">
      <div class="title">选择搜索订单</div>
      <div class="tagBox">
        <div class="item" @click="getOrderType('代购')">代购订单</div>
        <div class="item" @click="getOrderType('取件')">取件订单</div>
        <div class="item" @click="getOrderType('寄件')">寄件订单</div>
      </div>
    </div>

    <div class="searchResult" v-if="searchList.length!=0">
      <!--代购-->
      <div class="item" v-if="orderType=='代购' || orderType==''">
        <div class="title">代购订单</div>
        <div class="content"
             v-for="(mItem,mIndex) in searchList.market_service_list"
             :key="mIndex"
             v-if="searchList.market_service_list.length!=0"
             @click="toContent('/dgOrderContent',mItem.service_status,mItem.id)"
        >
          <div class="top flexBetween">
            <div class="left">
              <span :class="mItem.service_status==0?'cancel':'normal'">代购-{{mItem.service_status_name}}</span>
              <span class="time">{{mItem.create_time}}</span>
            </div>
            <div class="right"></div>
          </div>
          <div class="bottom">
            <div class="address">{{mItem.service_address.address+mItem.service_address.building_room}}</div>
            <div class="info flexBetween">
              <div class="left">
                <span class="name">{{mItem.service_address.contacts}}</span>
                <span class="tel">{{mItem.service_address.mobile}}</span>
              </div>
              <div class="right">共{{mItem.item_lists.length}}件</div>
            </div>
          </div>
        </div>
        <div class="noResult" v-if="!searchList.market_service_list">
          无搜索结果
        </div>
      </div>
      <!--取件-->
      <div class="item" v-if="orderType=='取件' || orderType==''">
        <div class="title">取件订单</div>
        <div class="content"
             v-for="(mItem,mIndex) in searchList.express_receipt_list"
             :key="mIndex"
             v-if="searchList.express_receipt_list.length!=0"
             @click="toContent('/qjOrderContent',mItem.status,mItem.id)"
        >
          <div class="top flexBetween">
            <div class="left">
              <span class="cancel" v-if="mItem.status==0">取件-{{mItem.status_name}}</span>
              <span class="danger" v-if="mItem.status==1">取件-{{mItem.status_name}}</span>
              <span :class="mItem.status==50?'':'normal'" v-else>取件-{{mItem.status_name}}</span>
              <span class="time">{{mItem.create_time}}</span>
            </div>
            <div class="right"></div>
          </div>
          <div class="bottom">
            <div class="address">{{mItem.express_address.address+mItem.express_address.building_room}}</div>
            <div class="info flexBetween">
              <div class="left">
                <span class="name">{{mItem.express_address.contacts}}</span>
                <span class="tel">{{mItem.express_address.mobile}}</span>
              </div>
              <div class="right">共{{mItem.qty}}件</div>
            </div>
          </div>
        </div>
        <div class="noResult" v-if="!searchList.express_receipt_list">
          无搜索结果
        </div>
      </div>
      <!--寄件-->
      <div class="item" v-if="orderType=='寄件' || orderType==''">
        <div class="title">寄件订单</div>
        <div class="content"
             v-for="(mItem,mIndex) in searchList.express_delivery_list"
             :key="mIndex"
             v-if="searchList.express_delivery_list.length!=0"
             @click="toContent('/jjOrderContent',mItem.status,mItem.id)"
        >
          <div class="top flexBetween">
            <div class="left">
              <span class="cancel" v-if="mItem.status==0">寄件-{{mItem.status_name}}</span>
              <span class="danger" v-if="mItem.status==1">寄件-{{mItem.status_name}}</span>
              <span :class="mItem.status==50?'':'normal'" v-else>寄件-{{mItem.status_name}}</span>
              <span class="time">{{mItem.create_time}}</span>
            </div>
            <div class="right"></div>
          </div>
          <div class="bottom">
            <div class="address">{{mItem.express_address.address+mItem.express_address.building_room}}</div>
            <div class="info flexBetween">
              <div class="left">
                <span class="name">{{mItem.express_address.contacts}}</span>
                <span class="tel">{{mItem.express_address.mobile}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="noResult" v-if="!searchList.express_delivery_list">
          无搜索结果
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Search} from 'vant';

  Vue.use(Search);
  export default {
    name: "search",
    data() {
      return {
        searchType: '请输入姓名或手机号',
        searchWord: '',
        orderType: '',
        searchList:[]
      }
    },
    methods: {
      toContent(url,status,id){
        this.$router.push({
          path:url,
          query:{
            status:status,
            id:id
          }
        })
      },
      //获取订单类型
      getOrderType(str) {
        this.searchType = `请输入${str}订单的姓名或手机号`;
        this.orderType = str;
      },
      onSearch(val) {
        let [is_search_market_service,is_search_express_receipt,is_search_express_delivery] = [1,1,1];
        if(this.orderType){
          is_search_market_service = (this.orderType == '代购' ? 1 : 0);
          is_search_express_receipt = (this.orderType == '取件' ? 1 : 0);
          is_search_express_delivery = (this.orderType == '寄件' ? 1 : 0);
        }

        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/marketservice/ordersearch`,
          data: {
            is_search_market_service,
            is_search_express_receipt,
            is_search_express_delivery,
            keyword: val
          }
        }).then(res => {
          if(res.code==0){
            this.searchList = res.data;
          }
          console.log(res)
        })

      },
      //取消搜索
      onCancel() {
        this.$router.go(-1);
      }
    }
  }
</script>

<style scoped lang="less">
  .searchBox {
    .van-search__action:active {
      background: none;
    }

    van-icon-search {
      font-size: 20px;
      color: #333;
    }

    .searchResult {
      .item {
        .title {
          padding: 0 14px;
          font-weight: bold;
          background: #F5f5f5;
          line-height: 44px;

        }

        .content {
          background: #fff;
          padding: 0 14px;
          margin-bottom: 6px;

          .top {
            line-height: 44px;
            font-size: 14px;
            border-bottom: 1px solid #f5f5f5;

            .left {
              .normal {
                color: #687BFF;
              }

              .danger {
                color: #DE1919;
              }
              .cancel{
                color: #8D95A6;
              }

              .time {
                margin-left: 12px;
                font-size: 12px;
                color: #8D95A6;
              }
            }

            .right {
              width: 7.2px;
              height: 12px;
              background: url("../assets/images/rtArrow.png") no-repeat;
              background-size: contain;
            }

          }

          .bottom {
            padding: 14px;

            .address {
              font-size: 14px;
              padding-bottom: 8px;
            }

            .info {
              font-size: 14px;

              .left {
                font-size: 13px;

                .name {
                  color: #687BFF;
                  margin-right: 10px;
                }

                .tel {
                  color: #8D95A6;
                }
              }

            }
          }
        }

        .noResult {
          background: #fff;
          text-align: center;
          color: #8D95A6;
          padding: 12px 0;
        }
      }
    }

    background: #f5f5f5;
    height: 100%;
    width: 100%;
    position: absolute;

    .selectSearch {
      margin: 66px 24px;

      .title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 12px;
      }

      .tagBox {
        display: flex;
        justify-content: left;
        flex-direction: row;
        flex-wrap: wrap;

        .item {
          background: #fff;
          padding: 5px 19px;
          font-size: 14px;
          margin-right: 12px;
        }
      }
    }

    .van-search__content--round {
      border: 1px solid #687BFF;
      background: #fff;
    }

    .van-search__action {
      color: #666;
      margin: 0 0.3rem;

    }
  }
</style>
<style>
  .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
    color: #fff;
    background: url("../assets/images/searchIcon.png") no-repeat center;
    background-size: contain;
    margin-right: 5px;
  }
</style>
